import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { acceptedItems, guideFaqs, rejectedItems } from "@/mocks/guide";

export default function GuideRules() {
  return (
    <>
      <section id="rules" className="bg-background-100 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-2xl mb-10">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">内容受理规范</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              我们不做立场判断，只看内容是否具备可核实的事实基础。下面两张清单可以帮助你判断自己的信息是否适合提交。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="bg-background-50 border border-primary-200 rounded-lg p-6 md:p-7">
              <div className="flex items-center gap-3 mb-5">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
                </span>
                <h3 className="font-heading font-semibold text-lg text-foreground-950">通常会被受理</h3>
              </div>
              <ul className="space-y-4">
                {acceptedItems.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                    <i className="ri-check-line text-primary-600 mt-0.5" aria-hidden="true"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-7">
              <div className="flex items-center gap-3 mb-5">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-close-circle-line" aria-hidden="true"></i>
                </span>
                <h3 className="font-heading font-semibold text-lg text-foreground-950">不在受理范围</h3>
              </div>
              <ul className="space-y-4">
                {rejectedItems.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-600">
                    <i className="ri-subtract-line text-secondary-500 mt-0.5" aria-hidden="true"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="guide-faq" className="bg-background-50 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
            <div className="lg:col-span-4">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">投稿细节答疑</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                关于篇幅、设备和后续跟进，这里集中回答几个最常被问到的问题。
              </p>
              <Link
                to="/faq"
                className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                更多常见问题
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
            <div className="lg:col-span-8">
              <FaqAccordion items={guideFaqs} defaultOpen={0} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}